import { Check } from '@tempo-io/sui-icons';
import { Spinner } from '@tempo-io/sui-spinner';

interface FieldStatusIndicatorProps {
  isPending?: boolean;
  isSuccess?: boolean;
}

export const FieldStatusIndicator = ({ isPending, isSuccess }: FieldStatusIndicatorProps) => {
  if (isPending) {
    return (
      <div className="flex items-center text-text-neutral-secondary">
        <Spinner />
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div className="flex items-center">
        <Check className="h-4 w-4 text-text-success" />
      </div>
    );
  }

  return null;
};
